'use strict';

var dateFns = require('date-fns');

// src/board/utils-filter.ts

// src/board/filter.ts
var FilterMatchStrategy = /* @__PURE__ */ ((FilterMatchStrategy2) => {
  FilterMatchStrategy2["And"] = "AND";
  FilterMatchStrategy2["Or"] = "OR";
  return FilterMatchStrategy2;
})(FilterMatchStrategy || {});
var FilterOperatorCompare = /* @__PURE__ */ ((FilterOperatorCompare2) => {
  FilterOperatorCompare2["Equals"] = "EQUALS";
  FilterOperatorCompare2["Includes"] = "INCLUDES";
  FilterOperatorCompare2["NotEqual"] = "NOT_EQUAL";
  FilterOperatorCompare2["NotIncludes"] = "NOT_INCLUDES";
  return FilterOperatorCompare2;
})(FilterOperatorCompare || {});
var FilterOperatorDate = /* @__PURE__ */ ((FilterOperatorDate2) => {
  FilterOperatorDate2["CurrentMonth"] = "CURRENT_MONTH";
  FilterOperatorDate2["CurrentWeek"] = "CURRENT_WEEK";
  FilterOperatorDate2["Date"] = "DATE";
  FilterOperatorDate2["Equals"] = "EQUALS";
  FilterOperatorDate2["LastMonth"] = "LAST_MONTH";
  FilterOperatorDate2["LastSevenDays"] = "LAST_SEVEN_DAYS";
  FilterOperatorDate2["LastWeek"] = "LAST_WEEK";
  FilterOperatorDate2["NextMonth"] = "NEXT_MONTH";
  FilterOperatorDate2["NextSevenDays"] = "NEXT_SEVEN_DAYS";
  FilterOperatorDate2["NextWeek"] = "NEXT_WEEK";
  FilterOperatorDate2["NotEquals"] = "NOT_EQUALS";
  FilterOperatorDate2["Range"] = "RANGE";
  FilterOperatorDate2["Today"] = "TODAY";
  FilterOperatorDate2["Tomorrow"] = "TOMORROW";
  FilterOperatorDate2["Yesterday"] = "YESTERDAY";
  return FilterOperatorDate2;
})(FilterOperatorDate || {});
var FilterOperatorNumber = /* @__PURE__ */ ((FilterOperatorNumber2) => {
  FilterOperatorNumber2["Equals"] = "EQUALS";
  FilterOperatorNumber2["Includes"] = "INCLUDES";
  FilterOperatorNumber2["Max"] = "MAX";
  FilterOperatorNumber2["MaxEquals"] = "MAX_EQUALS";
  FilterOperatorNumber2["Min"] = "MIN";
  FilterOperatorNumber2["MinEquals"] = "MIN_EQUALS";
  FilterOperatorNumber2["NotEquals"] = "NOT_EQUALS";
  FilterOperatorNumber2["NotIncludes"] = "NOT_INCLUDES";
  return FilterOperatorNumber2;
})(FilterOperatorNumber || {});
var FilterOperatorString = /* @__PURE__ */ ((FilterOperatorString2) => {
  FilterOperatorString2["Contains"] = "CONTAINS";
  FilterOperatorString2["EndsWith"] = "ENDS_WITH";
  FilterOperatorString2["Equals"] = "EQUALS";
  FilterOperatorString2["NotContains"] = "NOT_CONTAINS";
  FilterOperatorString2["NotEqual"] = "NOT_EQUAL";
  FilterOperatorString2["StartsWith"] = "STARTS_WITH";
  return FilterOperatorString2;
})(FilterOperatorString || {});
var TableColumnValueType = /* @__PURE__ */ ((TableColumnValueType2) => {
  TableColumnValueType2["Bool"] = "BOOL";
  TableColumnValueType2["Date"] = "DATE";
  TableColumnValueType2["Number"] = "NUMBER";
  TableColumnValueType2["Select"] = "SELECT";
  TableColumnValueType2["String"] = "STRING";
  return TableColumnValueType2;
})(TableColumnValueType || {});

// src/board/utils-filter.ts
var fieldTypeCompare = {
  ["OR" /* Or */]: (proValue, inValues) => {
    if ((inValues == null ? void 0 : inValues.includes("EMPTY")) && !proValue) {
      return true;
    }
    return inValues == null ? void 0 : inValues.some((v) => v === proValue);
  },
  ["AND" /* And */]: (proValue, inValues) => {
    if ((inValues == null ? void 0 : inValues.includes("EMPTY")) && !proValue) {
      return true;
    }
    return inValues == null ? void 0 : inValues.every((v) => v === proValue);
  }
};
var fieldTypeArrayCompare = {
  ["OR" /* Or */]: (proValues, inValues) => {
    const set = new Set(Array.isArray(proValues) ? proValues : [proValues]);
    if (!(proValues == null ? void 0 : proValues.length)) {
      return false;
    }
    return inValues == null ? void 0 : inValues.some((v) => set.has(v));
  },
  ["AND" /* And */]: (proValues, inValues) => {
    const set = new Set(Array.isArray(proValues) ? proValues : [proValues]);
    if (!(proValues == null ? void 0 : proValues.length)) {
      return false;
    }
    return inValues == null ? void 0 : inValues.every((v) => set.has(v));
  }
};
var scapeRegex = (value) => {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
};
var stringCompare = {
  ["CONTAINS" /* Contains */]: (value) => ({
    $regex: scapeRegex(value),
    $options: "igm"
  }),
  ["NOT_CONTAINS" /* NotContains */]: (value) => ({
    $regex: `^((?!${scapeRegex(value)}).)*$`,
    $options: "igm"
  }),
  ["STARTS_WITH" /* StartsWith */]: (value) => ({
    $regex: `^${scapeRegex(value)}+.`,
    $options: "igm"
  }),
  ["ENDS_WITH" /* EndsWith */]: (value) => ({
    $regex: `.+${scapeRegex(value)}$`,
    $options: "igm"
  })
};
var FilterOperatorNumberCompare = {
  ["EQUALS" /* Equals */]: (a, b) => a === b,
  ["NOT_EQUALS" /* NotEquals */]: (a, b) => a !== b,
  ["MAX" /* Max */]: (a, b) => a < b,
  ["MIN" /* Min */]: (a, b) => a > b,
  ["MAX_EQUALS" /* MaxEquals */]: (a, b) => a <= b,
  ["MIN_EQUALS" /* MinEquals */]: (a, b) => a >= b
};
var boolOperatorCompare = {
  ["EQUALS" /* Equals */]: (a, b) => a === b,
  ["NOT_EQUALS" /* NotEquals */]: (a, b) => a && b ? a !== b : true
};
function parseDate(value, range, dateParam) {
  const now = /* @__PURE__ */ new Date();
  const periods = {
    ["DATE" /* Date */]: () => {
      if (!dateParam) {
        throw new Error("Missing date");
      }
      const d = new Date(dateParam);
      return [dateFns.startOfDay(d), dateFns.endOfDay(d)];
    },
    ["RANGE" /* Range */]: () => {
      if (!range) {
        throw new Error("Missing range dates");
      }
      return [dateFns.startOfDay(new Date(range[0])), dateFns.endOfDay(new Date(range[1]))];
    },
    ["TODAY" /* Today */]: () => [dateFns.startOfDay(now), dateFns.endOfDay(now)],
    ["YESTERDAY" /* Yesterday */]: () => {
      const date = dateFns.subDays(now, 1);
      return [dateFns.startOfDay(date), dateFns.endOfDay(date)];
    },
    ["TOMORROW" /* Tomorrow */]: () => {
      const date = dateFns.addDays(now, 1);
      return [dateFns.startOfDay(date), dateFns.endOfDay(date)];
    },
    ["NEXT_SEVEN_DAYS" /* NextSevenDays */]: () => {
      const date = dateFns.addDays(now, 7);
      return [dateFns.startOfDay(now), dateFns.endOfDay(date)];
    },
    ["LAST_SEVEN_DAYS" /* LastSevenDays */]: () => {
      const date = dateFns.subDays(now, 7);
      return [dateFns.startOfDay(date), dateFns.endOfDay(now)];
    },
    ["CURRENT_WEEK" /* CurrentWeek */]: () => [
      dateFns.startOfDay(dateFns.startOfWeek(now)),
      dateFns.endOfDay(dateFns.endOfWeek(now))
    ],
    ["LAST_WEEK" /* LastWeek */]: () => {
      const date = dateFns.subDays(now, 7);
      return [dateFns.startOfDay(dateFns.startOfWeek(date)), dateFns.endOfDay(dateFns.endOfWeek(date))];
    },
    ["NEXT_WEEK" /* NextWeek */]: () => {
      const date = dateFns.addDays(now, 7);
      return [dateFns.startOfDay(dateFns.startOfWeek(date)), dateFns.endOfDay(dateFns.endOfWeek(date))];
    },
    ["CURRENT_MONTH" /* CurrentMonth */]: () => [
      dateFns.startOfDay(dateFns.startOfMonth(now)),
      dateFns.endOfDay(dateFns.endOfMonth(now))
    ],
    ["LAST_MONTH" /* LastMonth */]: () => {
      const date = dateFns.subMonths(now, 1);
      return [dateFns.startOfDay(dateFns.startOfMonth(date)), dateFns.endOfDay(dateFns.endOfMonth(date))];
    },
    ["NEXT_MONTH" /* NextMonth */]: () => {
      const date = dateFns.addMonths(now, 1);
      return [dateFns.startOfDay(dateFns.startOfMonth(date)), dateFns.endOfDay(dateFns.endOfMonth(date))];
    },
    default: () => {
      throw new Error("Invalid period");
    }
  };
  const [start, end] = (periods[value] || periods.default)();
  return [dateFns.getTime(start), dateFns.getTime(end)];
}
var defaultValueExtractor = (object, prop) => {
  var _a;
  return (_a = object.columns.find((c) => c.columnId === prop)) == null ? void 0 : _a.value;
};
var getSelectCompare = (condition) => {
  const { matchStrategy, operator } = condition;
  const compare = (v) => fieldTypeArrayCompare[matchStrategy || "OR" /* Or */](
    v,
    condition.value
  );
  if (operator === "NOT_INCLUDES" /* NotIncludes */) {
    return [condition.columnId, (v) => !compare(v)];
  }
  return [condition.columnId, (v) => compare(v)];
};
var getNumberCompare = (condition) => {
  const { operator, value } = condition;
  const compare = (v) => operator === "INCLUDES" /* Includes */ || operator === "NOT_INCLUDES" /* NotIncludes */ ? fieldTypeCompare["OR" /* Or */](v, value) : FilterOperatorNumberCompare[operator](v, value);
  if (operator === "NOT_INCLUDES" /* NotIncludes */) {
    return [condition.columnId, (v) => !compare(v)];
  }
  return [condition.columnId, (v) => compare(v)];
};
var getBooleanCompare = (condition) => {
  const { operator } = condition;
  const compare = (v) => boolOperatorCompare[operator](v, condition.value);
  return [condition.columnId, (v) => compare(v)];
};
var getStringCompare = (condition) => {
  const { operator, value } = condition;
  const regexFunction = (v) => {
    const { $regex, $options } = stringCompare[operator](value);
    const reg = new RegExp($regex, $options);
    return !!String(v).match(reg);
  };
  const compare = (v) => regexFunction(v);
  if (operator === "NOT_CONTAINS" /* NotContains */) {
    return [condition.columnId, (v) => !compare(v)];
  }
  return [condition.columnId, (v) => compare(v)];
};
var getDateCompare = (condition) => {
  const compare = (d) => {
    const [start, end] = parseDate(
      condition.operator,
      [condition.dateStart, condition.dateEnd],
      condition.date
    );
    const _d = dateFns.getTime(dateFns.parseISO(d));
    return FilterOperatorNumberCompare["MIN_EQUALS" /* MinEquals */](_d, start) && FilterOperatorNumberCompare["MAX_EQUALS" /* MaxEquals */](_d, end);
  };
  if (condition.operator === "NOT_EQUALS" /* NotEquals */) {
    return [condition.columnId, (v) => !compare(v)];
  }
  return [condition.columnId, (v) => compare(v)];
};
function buildMatcher(filter) {
  const matchers = filter.conditions.map(
    // @ts-ignore
    (condition) => {
      if (condition.valueType === "SELECT" /* Select */) {
        return getSelectCompare(condition);
      }
      if (condition.valueType === "NUMBER" /* Number */) {
        return getNumberCompare(condition);
      }
      if (condition.valueType === "STRING" /* String */) {
        return getStringCompare(condition);
      }
      if (condition.valueType === "DATE" /* Date */) {
        return getDateCompare(condition);
      }
      if (condition.valueType === "BOOL" /* Bool */) {
        return getBooleanCompare(condition);
      }
    }
  );
  return (obj) => matchers[filter.matchStrategy === "AND" /* And */ ? "every" : "some"](([prop, match]) => {
    const value = defaultValueExtractor(obj, prop);
    return value ? match(value) : false;
  });
}

exports.FilterMatchStrategy = FilterMatchStrategy;
exports.FilterOperatorCompare = FilterOperatorCompare;
exports.FilterOperatorDate = FilterOperatorDate;
exports.FilterOperatorNumber = FilterOperatorNumber;
exports.FilterOperatorString = FilterOperatorString;
exports.TableColumnValueType = TableColumnValueType;
exports.buildMatcher = buildMatcher;
